export const DARK_MODE_AUTO = 'auto'
/* DARK_MODE_OFF is a no-op */
export const DARK_MODE_OFF = 'off'
export const DARK_MODE_ON = 'on'
